(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lts-cv__play');
    if (!btn) return;
    var tile = btn.closest('.lts-cv__tile');
    var tpl = tile && tile.querySelector('template');
    if (!tpl) return;
    document.querySelectorAll('.lts-cv__tile video').forEach(function (v) { v.pause(); });
    var holder = document.createElement('div');
    holder.appendChild(tpl.content.cloneNode(true));
    var v = holder.querySelector('video');
    if (!v) return;
    v.setAttribute('playsinline', '');
    btn.hidden = true;
    tile.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  });
})();
